export default class Case {
    title = "";
    description = "";
    comments = [];
    dateAdded = new Date().toISOString().substr(0, 10);
    dateAddedTimestamp = 0;
    category = [];
    organisation = "";
    ownerName = "";
    owner = "";
    public = true;
    upvotes = 0;
    lastModified = new Date().toISOString().substr(0, 10);
    lastModifiedTimestamp = 0;
    treatments = [];
 
    constructor(Title, Description, Comments, DateAdded, DateAddedTimestamp, Category, Organisation, OwnerName, Owner, Public, Upvotes, LastModified, LastModifiedTimestamp, Treatments) 
    {
      //Used Tenary operator to determine whether anything was entered/the parameter is defined. If not, set as the default  
      Title ? this.title = Title : this.title = "";
      Description ? this.description = Description : this.description = "";
      Comments ? this.comments = Comments : this.comments = [];
      DateAdded ? this.dateAdded = DateAdded : this.dateAdded = new Date().toISOString().substr(0, 10);
      DateAddedTimestamp ? this.dateAddedTimestamp = DateAddedTimestamp : this.dateAddedTimestamp =(new Date(this.dateAdded).getTime() / 1000);
      Category ? this.category = Category : this.category = [];
      Organisation ? this.organisation = Organisation : this.organisation = "";
      OwnerName ? this.ownerName = OwnerName : this.ownerName = "";
      Owner ? this.owner = Owner : this.owner = "";
      Public ? this.public = Public : this.public = true;
      Upvotes ? this.upvotes = Upvotes : this.upvotes = 0;
      LastModified ? this.lastModified = LastModified : this.lastModified = new Date().toISOString().substr(0,10);
      LastModifiedTimestamp ? this.lastModifiedTimestamp = LastModifiedTimestamp : this.lastModifiedTimestamp = (new Date(this.lastModified).getTime() / 1000);
      Treatments ? this.treatments = Treatments : this.treatments = [];
    }

    async validateCase(rules, userId){
      var that = this;
      return new Promise(async function(resolve){
          //Validate the current form entry
          var errorList = [];
          var errorMessage = "";

          //First validate generic entry
          //Title
          if (that.title.length < rules.title.min){
          errorList.push("Title must be a minimum length of " + rules.title.min);
          } else if (that.title.length > rules.title.max){
          errorList.push("Title exceeds maximum length of " + rules.title.max);
          }
          //Category
          if (that.category.length < rules.category.min)
          {
          errorList.push("You must have at least one category selected");          
          }
          //Description
          if (that.description.length < rules.description.min){
          errorList.push("Description must be a minimum length of " + rules.description.min);
          } else if (that.description.length > rules.description.max){
          errorList.push("Description exceeds maximum length of " + rules.description.max);
          }
          
          //User Validation
          //Just check that the owner id is = to the userId input
          if (that.owner !== userId){
            errorList.push("Only the owner of this treatment may modify it");                
          }

          //Will need to have some validation for this part (something to do whether its a valid case to add) this.updateTreatmentCaseStatus();

          //Produce the error messages in here (push into a list, display a swal at the end)
          if (errorList.length > 0){
          for (var i = 0; i < errorList.length; i++){
              if (i === 0){
              errorMessage = "-" + errorList[i];              
              } else {
              errorMessage = errorMessage + ", \n-" + errorList[i];              
              }
          }

          resolve({result: false, errorMessage: errorMessage});
          } else {
          resolve(true);
          }  
      });
    }
}